export default function placementHelper(moduleProps, root, isForced) {
    const rightRailElement = document.getElementById('WikiaRail');
    const rightRailStickyElement = document.querySelector('.sticky-modules-wrapper');
    if (rightRailElement) {
        const insertionPoint = rightRailStickyElement;
        insertionPoint.before(root);
        return true;
    }
    // if we're forcing, just add it to the bottom of the body
    if (isForced) {
        moduleProps.log.error('Push to discussions discovery unit on right rail forced, but insertion point cannot be found, appending disc unit to the body');
        document.body.appendChild(root);
        return true;
    }
    moduleProps.log.error('Error in insertion of push to discussions discovery unit on right rail due to lack of insertion point on page');
    return false;
}
